import React from 'react';
import { apiService } from '../services/apiService';
import UserAvatar from './UserAvatar';
import { DSButton } from '../design-system/primitives';
import { usePhotoUpload } from '../hooks/usePhotoUpload';
import './ProfilePhotoControl.css';

/**
 * A member's profile photo with upload, replace and remove.
 *
 * The photo shows on the hallway sign when they host. Picking, shrinking and the
 * size check live in usePhotoUpload. `onChange` gets the new photo_url (or null)
 * so the page can refresh what it shows.
 */
function ProfilePhotoControl({ person, onChange, hint }) {
  const userId = person.id;
  const photo = usePhotoUpload({
    upload: (file) => apiService.uploadProfilePhoto(userId, file),
    remove: () => apiService.deleteProfilePhoto(userId),
    onChange,
    fileName: 'profile.jpg'
  });

  const hasPhoto = Boolean(person.photo_url);

  return (
    <div className="profile-photo">
      <UserAvatar person={person} className="profile-photo__frame" />
      <div className="profile-photo__body">
        {hint && <p className="profile-photo__hint">{hint}</p>}
        <div className="profile-photo__actions">
          <DSButton appearance="outline" tone="neutral" size="sm" disabled={photo.busy} onClick={photo.pick}>
            {hasPhoto ? 'Replace photo' : 'Upload photo'}
          </DSButton>
          {hasPhoto && (
            <DSButton appearance="text" tone="neutral" size="sm" disabled={photo.busy} onClick={photo.remove}>
              Remove
            </DSButton>
          )}
        </div>
      </div>
      <input {...photo.inputProps} />
    </div>
  );
}

export default ProfilePhotoControl;
